"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var misc_1 = require("@sentry/utils/misc");
// TODO: Implement different loggers for different environments
var global = misc_1.getGlobalObject();
/** JSDoc */
var Logger = /** @class */function () {
  /** JSDoc */
  function Logger() {
    this.console = global.console;
    this.disabled = true;
  }
  /** JSDoc */
  Logger.prototype.disable = function () {
    this.disabled = true;
  };
  /** JSDoc */
  Logger.prototype.enable = function () {
    this.disabled = false;
  };
  /** JSDoc */
  Logger.prototype.log = function (message) {
    if (this.disabled) {
      return;
    }
    this.console.log("Sentry Logger [Log]: " + message); // tslint:disable-line:no-console
  };
  /** JSDoc */
  Logger.prototype.warn = function (message) {
    if (this.disabled) {
      return;
    }
    this.console.warn("Sentry Logger [Warn]: " + message); // tslint:disable-line:no-console
  };
  /** JSDoc */
  Logger.prototype.error = function (message) {
    if (this.disabled) {
      return;
    }
    this.console.error("Sentry Logger [Error]: " + message); // tslint:disable-line:no-console
  };
  return Logger;
}();
var logger = new Logger();
exports.logger = logger;